import React from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import Login from "./components/login/Login";
import SignUp from "./components/signUp/SignUp";
import PersonalCenter from "./components/personalCenter/PersonalCenter";
import Profile from "./components/personalCenter/children/profile/Profile";
import Setting from "./components/personalCenter/children/setting/Setting";
import Promotion from "./components/personalCenter/children/promotion/Promotion";
import History from "./components/personalCenter/children/history/History";
import Purchase from "./components/purchase/Purchase";
import ServicesRender from "./components/policy/ServicesRender";
import PrivacyRender from "./components/policy/PrivacyRender";
import Cookies from "js-cookie";

const RouterConfig = () => {
  /**
   *获取search
   */
  const getUrlParams = () => {
    let href = window.location.href;
    let urlSearch = href.indexOf("?") !== -1 ? href.substring(href.indexOf("?")) : "";
    return urlSearch;
  };

  const urlSearch = getUrlParams();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<App urlSearch={urlSearch} />}>
          {!Cookies.get("authorization") ? <Route path="" element={<Navigate to={`/login${urlSearch}`} />} /> : null}
          <Route path="login" element={<Login urlSearch={urlSearch} />} />
          <Route path="signUp" element={<SignUp urlSearch={urlSearch} />} />
          <Route path="personal-center" element={<PersonalCenter />}>
            <Route path="" element={<Navigate to="./profile" />} />
            <Route path="profile" element={<Profile />} />
            <Route path="history" element={<History />} />
            <Route path="setting" element={<Setting />} />
            <Route path="promotion" element={<Promotion />} />
          </Route>
          <Route path="purchase" element={<Purchase urlSearch={urlSearch} />} />
          <Route path="services-policy" element={<ServicesRender urlSearch={urlSearch} />} />
          <Route path="privacy-policy" element={<PrivacyRender urlSearch={urlSearch} />} />
        </Route>
      </Routes>
    </Router>
  );
};
export default RouterConfig;
